export default [
  // Login
  {
    path: "/login",
    name: "login",
    meta: {
      is_auth: false,
      title: "Login",
      layout: "login",
    },
    component: () => import("@/views/auth/Login.vue"),
  },

  // Login redirect
  {
    path: "/login/redirect",
    name: "login-redirect",
    meta: {
      is_auth: false,
      title: "Login",
      layout: "login",
    },
    component: () => import("@/views/auth/Redirect.vue"),
  },

  // Login confirmation code
  {
    path: "/login/confirmation/code",
    name: "login-confirmation-code",
    meta: {
      is_auth: false,
      title: "Login",
      layout: "login",
    },
    component: () => import("@/views/auth/ConfirmationCode.vue"),
  },
];
